/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  ApClassInstanceRef,
  ApClassInstanceRefOptional,
  ApClassInstanceRefMetaI,
  ApClassInstanceRefTrackedI,
} from "./ap-class-instance-ref";
import {
  ApClassInstanceRefTracked,
  ApClassInstanceRefMeta,
} from "./ap-class-instance-ref";
// May contain unused imports in some cases
// @ts-ignore
import type {
  ApClassTypeRef,
  ApClassTypeRefOptional,
  ApClassTypeRefMetaI,
  ApClassTypeRefTrackedI,
} from "./ap-class-type-ref";
import { ApClassTypeRefTracked, ApClassTypeRefMeta } from "./ap-class-type-ref";
// May contain unused imports in some cases
// @ts-ignore
import type {
  CatalogItemCategoryDTO,
  CatalogItemCategoryDTOOptional,
  CatalogItemCategoryDTOMetaI,
  CatalogItemCategoryDTOTrackedI,
} from "./catalog-item-category-dto";
import {
  CatalogItemCategoryDTOTracked,
  CatalogItemCategoryDTOMeta,
} from "./catalog-item-category-dto";
// May contain unused imports in some cases
// @ts-ignore
import type {
  CatalogItemDiscountDTO,
  CatalogItemDiscountDTOOptional,
  CatalogItemDiscountDTOMetaI,
  CatalogItemDiscountDTOTrackedI,
} from "./catalog-item-discount-dto";
import {
  CatalogItemDiscountDTOTracked,
  CatalogItemDiscountDTOMeta,
} from "./catalog-item-discount-dto";
// May contain unused imports in some cases
// @ts-ignore
import type {
  CatalogItemInstanceDTO,
  CatalogItemInstanceDTOOptional,
  CatalogItemInstanceDTOMetaI,
  CatalogItemInstanceDTOTrackedI,
} from "./catalog-item-instance-dto";
import {
  CatalogItemInstanceDTOTracked,
  CatalogItemInstanceDTOMeta,
} from "./catalog-item-instance-dto";
// May contain unused imports in some cases
// @ts-ignore
import type {
  CatalogItemSharedDTO,
  CatalogItemSharedDTOOptional,
  CatalogItemSharedDTOMetaI,
  CatalogItemSharedDTOTrackedI,
} from "./catalog-item-shared-dto";
import {
  CatalogItemSharedDTOTracked,
  CatalogItemSharedDTOMeta,
} from "./catalog-item-shared-dto";
// May contain unused imports in some cases
// @ts-ignore
import type {
  CatalogItemTaxDTO,
  CatalogItemTaxDTOOptional,
  CatalogItemTaxDTOMetaI,
  CatalogItemTaxDTOTrackedI,
} from "./catalog-item-tax-dto";
import {
  CatalogItemTaxDTOTracked,
  CatalogItemTaxDTOMeta,
} from "./catalog-item-tax-dto";
// May contain unused imports in some cases
// @ts-ignore
import type {
  DamageWaiverTypeRef,
  DamageWaiverTypeRefOptional,
  DamageWaiverTypeRefMetaI,
  DamageWaiverTypeRefTrackedI,
} from "./damage-waiver-type-ref";
import {
  DamageWaiverTypeRefTracked,
  DamageWaiverTypeRefMeta,
} from "./damage-waiver-type-ref";
// May contain unused imports in some cases
// @ts-ignore
import type {
  ItemAgreementDTO,
  ItemAgreementDTOOptional,
  ItemAgreementDTOMetaI,
  ItemAgreementDTOTrackedI,
} from "./item-agreement-dto";
import {
  ItemAgreementDTOTracked,
  ItemAgreementDTOMeta,
} from "./item-agreement-dto";
// May contain unused imports in some cases
// @ts-ignore
import type {
  ItemType,
  ItemTypeOptional,
  ItemTypeMetaI,
  ItemTypeTrackedI,
} from "./item-type";
import { ItemTypeTracked, ItemTypeMeta } from "./item-type";
// May contain unused imports in some cases
// @ts-ignore
import type {
  MembershipTypeRef,
  MembershipTypeRefOptional,
  MembershipTypeRefMetaI,
  MembershipTypeRefTrackedI,
} from "./membership-type-ref";
import {
  MembershipTypeRefTracked,
  MembershipTypeRefMeta,
} from "./membership-type-ref";
// May contain unused imports in some cases
// @ts-ignore
import type {
  ProductRef,
  ProductRefOptional,
  ProductRefMetaI,
  ProductRefTrackedI,
} from "./product-ref";
import { ProductRefTracked, ProductRefMeta } from "./product-ref";

/**
 *
 * @export
 * @interface CatalogItemDTO
 */
export interface CatalogItemDTOOptional extends CatalogItemSharedDTOOptional {
  /**
   *
   * @type {boolean}
   * @memberof CatalogItemDTO
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof CatalogItemDTO
   */
  isNew?: boolean;
  /**
   *
   * @type {number}
   * @memberof CatalogItemDTO
   */
  assignId?: number;
  /**
   *
   * @type {string}
   * @memberof CatalogItemDTO
   */
  tempID?: string;
  /**
   *
   * @type {ItemType}
   * @memberof CatalogItemDTO
   */
  itemType?: ItemType;
  /**
   *
   * @type {string}
   * @memberof CatalogItemDTO
   */
  itemName?: string;
  /**
   *
   * @type {string}
   * @memberof CatalogItemDTO
   */
  itemDescription?: string;
  /**
   *
   * @type {string}
   * @memberof CatalogItemDTO
   */
  imageURL?: string;
  /**
   *
   * @type {string}
   * @memberof CatalogItemDTO
   */
  itemSKU?: string;
  /**
   *
   * @type {string}
   * @memberof CatalogItemDTO
   */
  squareItemId?: string;
  /**
   * Default expiration duration in seconds for line items of this item type
   * @type {number}
   * @memberof CatalogItemDTO
   */
  expirationDurationSeconds?: number;
  /**
   *
   * @type {ApClassTypeRef}
   * @memberof CatalogItemDTO
   */
  classTypeId?: ApClassTypeRefOptional;
  /**
   *
   * @type {ApClassInstanceRef}
   * @memberof CatalogItemDTO
   */
  classInstanceId?: ApClassInstanceRefOptional;
  /**
   *
   * @type {MembershipTypeRef}
   * @memberof CatalogItemDTO
   */
  membershipTypeId?: MembershipTypeRefOptional;
  /**
   *
   * @type {DamageWaiverTypeRef}
   * @memberof CatalogItemDTO
   */
  damageWaiverTypeId?: DamageWaiverTypeRefOptional;
  /**
   *
   * @type {ProductRef}
   * @memberof CatalogItemDTO
   */
  productId?: ProductRefOptional;
  /**
   *
   * @type {Array<CatalogItemInstanceDTO>}
   * @memberof CatalogItemDTO
   */
  itemInstances?: CatalogItemInstanceDTOOptional[];
  /**
   *
   * @type {Array<CatalogItemCategoryDTO>}
   * @memberof CatalogItemDTO
   */
  itemCategories?: CatalogItemCategoryDTOOptional[];
  /**
   *
   * @type {Array<ItemAgreementDTO>}
   * @memberof CatalogItemDTO
   */
  itemAgreements?: ItemAgreementDTOOptional[];
  /**
   *
   * @type {string}
   * @memberof CatalogItemDTO
   */
  updatedOn?: Date;
  /**
   *
   * @type {string}
   * @memberof CatalogItemDTO
   */
  updatedBy?: string;
  /**
   *
   * @type {string}
   * @memberof CatalogItemDTO
   */
  createdOn?: Date;
  /**
   *
   * @type {string}
   * @memberof CatalogItemDTO
   */
  createdBy?: string;
  /**
   *
   * @type {Array<CatalogItemDiscountDTO>}
   * @memberof CatalogItemDTO
   */
  itemDiscounts?: CatalogItemDiscountDTOOptional[];
  /**
   *
   * @type {Array<CatalogItemTaxDTO>}
   * @memberof CatalogItemDTO
   */
  itemTaxes?: CatalogItemTaxDTOOptional[];
}

export interface CatalogItemDTO
  extends CatalogItemDTOOptional, CatalogItemSharedDTO {
  /**
   *
   * @type {boolean}
   * @memberof CatalogItemDTO
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof CatalogItemDTO
   */
  isNew?: boolean;
  /**
   *
   * @type {number}
   * @memberof CatalogItemDTO
   */
  assignId: number;
  /**
   *
   * @type {string}
   * @memberof CatalogItemDTO
   */
  tempID?: string;
  /**
   *
   * @type {ItemType}
   * @memberof CatalogItemDTO
   */
  itemType?: ItemType;
  /**
   *
   * @type {string}
   * @memberof CatalogItemDTO
   */
  itemName?: string;
  /**
   *
   * @type {string}
   * @memberof CatalogItemDTO
   */
  itemDescription?: string;
  /**
   *
   * @type {string}
   * @memberof CatalogItemDTO
   */
  imageURL?: string;
  /**
   *
   * @type {string}
   * @memberof CatalogItemDTO
   */
  itemSKU?: string;
  /**
   *
   * @type {string}
   * @memberof CatalogItemDTO
   */
  squareItemId?: string;
  /**
   * Default expiration duration in seconds for line items of this item type
   * @type {number}
   * @memberof CatalogItemDTO
   */
  expirationDurationSeconds?: number;
  /**
   *
   * @type {ApClassTypeRef}
   * @memberof CatalogItemDTO
   */
  classTypeId?: ApClassTypeRef;
  /**
   *
   * @type {ApClassInstanceRef}
   * @memberof CatalogItemDTO
   */
  classInstanceId?: ApClassInstanceRef;
  /**
   *
   * @type {MembershipTypeRef}
   * @memberof CatalogItemDTO
   */
  membershipTypeId?: MembershipTypeRef;
  /**
   *
   * @type {DamageWaiverTypeRef}
   * @memberof CatalogItemDTO
   */
  damageWaiverTypeId?: DamageWaiverTypeRef;
  /**
   *
   * @type {ProductRef}
   * @memberof CatalogItemDTO
   */
  productId?: ProductRef;
  /**
   *
   * @type {Array<CatalogItemInstanceDTO>}
   * @memberof CatalogItemDTO
   */
  itemInstances?: CatalogItemInstanceDTO[];
  /**
   *
   * @type {Array<CatalogItemCategoryDTO>}
   * @memberof CatalogItemDTO
   */
  itemCategories?: CatalogItemCategoryDTO[];
  /**
   *
   * @type {Array<ItemAgreementDTO>}
   * @memberof CatalogItemDTO
   */
  itemAgreements?: ItemAgreementDTO[];
  /**
   *
   * @type {string}
   * @memberof CatalogItemDTO
   */
  updatedOn?: Date;
  /**
   *
   * @type {string}
   * @memberof CatalogItemDTO
   */
  updatedBy?: string;
  /**
   *
   * @type {string}
   * @memberof CatalogItemDTO
   */
  createdOn?: Date;
  /**
   *
   * @type {string}
   * @memberof CatalogItemDTO
   */
  createdBy?: string;
  /**
   *
   * @type {Array<CatalogItemDiscountDTO>}
   * @memberof CatalogItemDTO
   */
  itemDiscounts?: CatalogItemDiscountDTO[];
  /**
   *
   * @type {Array<CatalogItemTaxDTO>}
   * @memberof CatalogItemDTO
   */
  itemTaxes?: CatalogItemTaxDTO[];
}

export interface CatalogItemDTOTrackedI extends CatalogItemSharedDTOOptional {
  /**
   *
   * @type {boolean}
   * @memberof CatalogItemDTO
   */
  isDeleted?: boolean;
  isDeletedIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof CatalogItemDTO
   */
  isNew?: boolean;
  isNewIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof CatalogItemDTO
   */
  assignId?: number;
  assignIdIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof CatalogItemDTO
   */
  tempID?: string;
  tempIDIsSet: boolean;
  /**
   *
   * @type {ItemType}
   * @memberof CatalogItemDTO
   */
  itemType?: ItemType;
  itemTypeIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof CatalogItemDTO
   */
  itemName?: string;
  itemNameIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof CatalogItemDTO
   */
  itemDescription?: string;
  itemDescriptionIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof CatalogItemDTO
   */
  imageURL?: string;
  imageURLIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof CatalogItemDTO
   */
  itemSKU?: string;
  itemSKUIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof CatalogItemDTO
   */
  squareItemId?: string;
  squareItemIdIsSet: boolean;
  /**
   * Default expiration duration in seconds for line items of this item type
   * @type {number}
   * @memberof CatalogItemDTO
   */
  expirationDurationSeconds?: number;
  expirationDurationSecondsIsSet: boolean;
  /**
   *
   * @type {ApClassTypeRef}
   * @memberof CatalogItemDTO
   */
  classTypeId?: ApClassTypeRefTrackedI;
  classTypeIdIsSet: boolean;
  /**
   *
   * @type {ApClassInstanceRef}
   * @memberof CatalogItemDTO
   */
  classInstanceId?: ApClassInstanceRefTrackedI;
  classInstanceIdIsSet: boolean;
  /**
   *
   * @type {MembershipTypeRef}
   * @memberof CatalogItemDTO
   */
  membershipTypeId?: MembershipTypeRefTrackedI;
  membershipTypeIdIsSet: boolean;
  /**
   *
   * @type {DamageWaiverTypeRef}
   * @memberof CatalogItemDTO
   */
  damageWaiverTypeId?: DamageWaiverTypeRefTrackedI;
  damageWaiverTypeIdIsSet: boolean;
  /**
   *
   * @type {ProductRef}
   * @memberof CatalogItemDTO
   */
  productId?: ProductRefTrackedI;
  productIdIsSet: boolean;
  /**
   *
   * @type {Array<CatalogItemInstanceDTO>}
   * @memberof CatalogItemDTO
   */
  itemInstances?: CatalogItemInstanceDTOTrackedI[];
  itemInstancesIsSet: boolean;
  /**
   *
   * @type {Array<CatalogItemCategoryDTO>}
   * @memberof CatalogItemDTO
   */
  itemCategories?: CatalogItemCategoryDTOTrackedI[];
  itemCategoriesIsSet: boolean;
  /**
   *
   * @type {Array<ItemAgreementDTO>}
   * @memberof CatalogItemDTO
   */
  itemAgreements?: ItemAgreementDTOTrackedI[];
  itemAgreementsIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof CatalogItemDTO
   */
  updatedOn?: Date;
  updatedOnIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof CatalogItemDTO
   */
  updatedBy?: string;
  updatedByIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof CatalogItemDTO
   */
  createdOn?: Date;
  createdOnIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof CatalogItemDTO
   */
  createdBy?: string;
  createdByIsSet: boolean;
  /**
   *
   * @type {Array<CatalogItemDiscountDTO>}
   * @memberof CatalogItemDTO
   */
  itemDiscounts?: CatalogItemDiscountDTOTrackedI[];
  itemDiscountsIsSet: boolean;
  /**
   *
   * @type {Array<CatalogItemTaxDTO>}
   * @memberof CatalogItemDTO
   */
  itemTaxes?: CatalogItemTaxDTOTrackedI[];
  itemTaxesIsSet: boolean;
}

transformDatesMap.set("CatalogItemDTO", function (model: CatalogItemDTO) {
  const transformDatesclassTypeId = transformDatesMap.get("ApClassTypeRef");
  if (transformDatesclassTypeId && model.classTypeId) {
    transformDatesclassTypeId(model.classTypeId);
  }
  const transformDatesclassInstanceId =
    transformDatesMap.get("ApClassInstanceRef");
  if (transformDatesclassInstanceId && model.classInstanceId) {
    transformDatesclassInstanceId(model.classInstanceId);
  }
  const transformDatesmembershipTypeId =
    transformDatesMap.get("MembershipTypeRef");
  if (transformDatesmembershipTypeId && model.membershipTypeId) {
    transformDatesmembershipTypeId(model.membershipTypeId);
  }
  const transformDatesdamageWaiverTypeId = transformDatesMap.get(
    "DamageWaiverTypeRef",
  );
  if (transformDatesdamageWaiverTypeId && model.damageWaiverTypeId) {
    transformDatesdamageWaiverTypeId(model.damageWaiverTypeId);
  }
  const transformDatesproductId = transformDatesMap.get("ProductRef");
  if (transformDatesproductId && model.productId) {
    transformDatesproductId(model.productId);
  }
  const transformDatesitemInstances = transformDatesMap.get(
    "CatalogItemInstanceDTO",
  );
  if (transformDatesitemInstances) {
    model.itemInstances?.forEach((sub) => {
      transformDatesitemInstances(sub);
    });
  }
  const transformDatesitemCategories = transformDatesMap.get(
    "CatalogItemCategoryDTO",
  );
  if (transformDatesitemCategories) {
    model.itemCategories?.forEach((sub) => {
      transformDatesitemCategories(sub);
    });
  }
  const transformDatesitemAgreements =
    transformDatesMap.get("ItemAgreementDTO");
  if (transformDatesitemAgreements) {
    model.itemAgreements?.forEach((sub) => {
      transformDatesitemAgreements(sub);
    });
  }
  if (typeof model.updatedOn == "string")
    model.updatedOn = new Date(model.updatedOn);
  if (typeof model.createdOn == "string")
    model.createdOn = new Date(model.createdOn);
  const transformDatesitemDiscounts = transformDatesMap.get(
    "CatalogItemDiscountDTO",
  );
  if (transformDatesitemDiscounts) {
    model.itemDiscounts?.forEach((sub) => {
      transformDatesitemDiscounts(sub);
    });
  }
  const transformDatesitemTaxes = transformDatesMap.get("CatalogItemTaxDTO");
  if (transformDatesitemTaxes) {
    model.itemTaxes?.forEach((sub) => {
      transformDatesitemTaxes(sub);
    });
  }
});

export type CatalogItemDTOMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  isDeleted: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  isNew: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  assignId: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  tempID: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  itemType: PropertyMeta<ItemTypeMetaI>;
  //isDate: false
  //isDatetime: false
  itemName: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  itemDescription: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  imageURL: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  itemSKU: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  squareItemId: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  expirationDurationSeconds: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  classTypeId: PropertyMeta<ApClassTypeRefMetaI>;
  //isDate: false
  //isDatetime: false
  classInstanceId: PropertyMeta<ApClassInstanceRefMetaI>;
  //isDate: false
  //isDatetime: false
  membershipTypeId: PropertyMeta<MembershipTypeRefMetaI>;
  //isDate: false
  //isDatetime: false
  damageWaiverTypeId: PropertyMeta<DamageWaiverTypeRefMetaI>;
  //isDate: false
  //isDatetime: false
  productId: PropertyMeta<ProductRefMetaI>;
  //isDate: false
  //isDatetime: false
  itemInstances: PropertyMeta<CatalogItemInstanceDTOMetaI>;
  //isDate: false
  //isDatetime: false
  itemCategories: PropertyMeta<CatalogItemCategoryDTOMetaI>;
  //isDate: false
  //isDatetime: false
  itemAgreements: PropertyMeta<ItemAgreementDTOMetaI>;
  //isDate: false
  //isDatetime: true
  updatedOn: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: false
  updatedBy: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: true
  createdOn: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: false
  createdBy: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  itemDiscounts: PropertyMeta<CatalogItemDiscountDTOMetaI>;
  //isDate: false
  //isDatetime: false
  itemTaxes: PropertyMeta<CatalogItemTaxDTOMetaI>;
}>;

export var CatalogItemDTOMeta: CatalogItemDTOMetaI = {} as CatalogItemDTOMetaI;
CatalogItemDTOMeta = typeMeta("CatalogItemDTO", {
  isDeleted: propertyMeta(
    "isDeleted",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  isNew: propertyMeta("isNew", false, false, false, MetaTypesBase.boolean),
  assignId: propertyMeta("assignId", false, true, true, MetaTypesBase.number),
  tempID: propertyMeta("tempID", false, false, false, MetaTypesBase.string),
  itemType: propertyMeta("itemType", false, false, false, ItemTypeMeta),
  itemName: propertyMeta("itemName", false, false, false, MetaTypesBase.string),
  itemDescription: propertyMeta(
    "itemDescription",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  imageURL: propertyMeta("imageURL", false, false, false, MetaTypesBase.string),
  itemSKU: propertyMeta("itemSKU", false, false, false, MetaTypesBase.string),
  squareItemId: propertyMeta(
    "squareItemId",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  expirationDurationSeconds: propertyMeta(
    "expirationDurationSeconds",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  classTypeId: propertyMeta(
    "classTypeId",
    false,
    false,
    false,
    ApClassTypeRefMeta,
  ),
  classInstanceId: propertyMeta(
    "classInstanceId",
    false,
    false,
    false,
    ApClassInstanceRefMeta,
  ),
  membershipTypeId: propertyMeta(
    "membershipTypeId",
    false,
    false,
    false,
    MembershipTypeRefMeta,
  ),
  damageWaiverTypeId: propertyMeta(
    "damageWaiverTypeId",
    false,
    false,
    false,
    DamageWaiverTypeRefMeta,
  ),
  productId: propertyMeta("productId", false, false, false, ProductRefMeta),
  itemInstances: propertyMeta(
    "itemInstances",
    true,
    false,
    false,
    CatalogItemInstanceDTOMeta,
  ),
  itemCategories: propertyMeta(
    "itemCategories",
    true,
    false,
    false,
    CatalogItemCategoryDTOMeta,
  ),
  itemAgreements: propertyMeta(
    "itemAgreements",
    true,
    false,
    false,
    ItemAgreementDTOMeta,
  ),
  updatedOn: propertyMeta("updatedOn", false, false, false, MetaTypesBase.Date),
  updatedBy: propertyMeta(
    "updatedBy",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  createdOn: propertyMeta("createdOn", false, false, false, MetaTypesBase.Date),
  createdBy: propertyMeta(
    "createdBy",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  itemDiscounts: propertyMeta(
    "itemDiscounts",
    true,
    false,
    false,
    CatalogItemDiscountDTOMeta,
  ),
  itemTaxes: propertyMeta(
    "itemTaxes",
    true,
    false,
    false,
    CatalogItemTaxDTOMeta,
  ),
});

const metaI = CatalogItemDTOMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([CatalogItemSharedDTOMeta]);
  metaI.isDeleted.inheritedFrom = CatalogItemSharedDTOMeta.isDeleted;
  metaI.isNew.inheritedFrom = CatalogItemSharedDTOMeta.isNew;
  metaI.assignId.inheritedFrom = CatalogItemSharedDTOMeta.assignId;
  metaI.tempID.inheritedFrom = CatalogItemSharedDTOMeta.tempID;
  metaI.itemType.inheritedFrom = CatalogItemSharedDTOMeta.itemType;
  metaI.itemName.inheritedFrom = CatalogItemSharedDTOMeta.itemName;
  metaI.itemDescription.inheritedFrom =
    CatalogItemSharedDTOMeta.itemDescription;
  metaI.imageURL.inheritedFrom = CatalogItemSharedDTOMeta.imageURL;
  metaI.itemSKU.inheritedFrom = CatalogItemSharedDTOMeta.itemSKU;
  metaI.squareItemId.inheritedFrom = CatalogItemSharedDTOMeta.squareItemId;
  metaI.expirationDurationSeconds.inheritedFrom =
    CatalogItemSharedDTOMeta.expirationDurationSeconds;
  metaI.classTypeId.inheritedFrom = CatalogItemSharedDTOMeta.classTypeId;
  metaI.classInstanceId.inheritedFrom =
    CatalogItemSharedDTOMeta.classInstanceId;
  metaI.membershipTypeId.inheritedFrom =
    CatalogItemSharedDTOMeta.membershipTypeId;
  metaI.damageWaiverTypeId.inheritedFrom =
    CatalogItemSharedDTOMeta.damageWaiverTypeId;
  metaI.productId.inheritedFrom = CatalogItemSharedDTOMeta.productId;
  metaI.itemInstances.inheritedFrom = CatalogItemSharedDTOMeta.itemInstances;
  metaI.itemCategories.inheritedFrom = CatalogItemSharedDTOMeta.itemCategories;
  metaI.itemAgreements.inheritedFrom = CatalogItemSharedDTOMeta.itemAgreements;
  metaI.updatedOn.inheritedFrom = CatalogItemSharedDTOMeta.updatedOn;
  metaI.updatedBy.inheritedFrom = CatalogItemSharedDTOMeta.updatedBy;
  metaI.createdOn.inheritedFrom = CatalogItemSharedDTOMeta.createdOn;
  metaI.createdBy.inheritedFrom = CatalogItemSharedDTOMeta.createdBy;
  metaI.itemDiscounts.inheritedFrom = CatalogItemSharedDTOMeta.itemDiscounts;
  metaI.itemTaxes.inheritedFrom = CatalogItemSharedDTOMeta.itemTaxes;
});

export class CatalogItemDTOTracked
  extends CatalogItemSharedDTOTracked
  implements CatalogItemDTOTrackedI
{
  changeTracker: boolean = false;
  //isNew: boolean = false
  isDeleted__I?: boolean = undefined;
  isDeletedIsSet: boolean = false;
  set isDeleted(v: undefined | boolean) {
    if (v !== undefined) {
      this.isDeleted__I = v;
      this.isDeletedIsSet = true;
    } else {
      this.isDeleted__I = v || undefined;
      this.isDeletedIsSet = false;
    }
    this.changeTracker = true;
  }
  get isDeleted() {
    return this.isDeleted__I;
  }
  isNew__I?: boolean = undefined;
  isNewIsSet: boolean = false;
  set isNew(v: undefined | boolean) {
    if (v !== undefined) {
      this.isNew__I = v;
      this.isNewIsSet = true;
    } else {
      this.isNew__I = v || undefined;
      this.isNewIsSet = false;
    }
    this.changeTracker = true;
  }
  get isNew() {
    return this.isNew__I;
  }
  assignId__I?: number = undefined;

  get assignIdIsSet() {
    return this.assignId !== undefined;
  }
  set assignIdIsSet(v: boolean) {}
  set assignId(v: undefined | number) {
    if (v !== undefined) {
      this.assignId__I = v;
      this.assignIdIsSet = true;
    } else {
      this.assignId__I = v || undefined;
      this.assignIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get assignId() {
    return this.assignId__I;
  }
  tempID__I?: string = undefined;
  tempIDIsSet: boolean = false;
  set tempID(v: undefined | string) {
    if (v !== undefined) {
      this.tempID__I = v;
      this.tempIDIsSet = true;
    } else {
      this.tempID__I = v || undefined;
      this.tempIDIsSet = false;
    }
    this.changeTracker = true;
  }
  get tempID() {
    return this.tempID__I;
  }
  itemType__I?: ItemType = undefined;
  itemTypeIsSet: boolean = false;
  set itemType(v: undefined | ItemType) {
    if (v !== undefined) {
      this.itemType__I = v;
      this.itemTypeIsSet = true;
    } else {
      this.itemType__I = v || undefined;
      this.itemTypeIsSet = false;
    }
    this.changeTracker = true;
  }
  get itemType() {
    return this.itemType__I;
  }
  itemName__I?: string = undefined;
  itemNameIsSet: boolean = false;
  set itemName(v: undefined | string) {
    if (v !== undefined) {
      this.itemName__I = v;
      this.itemNameIsSet = true;
    } else {
      this.itemName__I = v || undefined;
      this.itemNameIsSet = false;
    }
    this.changeTracker = true;
  }
  get itemName() {
    return this.itemName__I;
  }
  itemDescription__I?: string = undefined;
  itemDescriptionIsSet: boolean = false;
  set itemDescription(v: undefined | string) {
    if (v !== undefined) {
      this.itemDescription__I = v;
      this.itemDescriptionIsSet = true;
    } else {
      this.itemDescription__I = v || undefined;
      this.itemDescriptionIsSet = false;
    }
    this.changeTracker = true;
  }
  get itemDescription() {
    return this.itemDescription__I;
  }
  imageURL__I?: string = undefined;
  imageURLIsSet: boolean = false;
  set imageURL(v: undefined | string) {
    if (v !== undefined) {
      this.imageURL__I = v;
      this.imageURLIsSet = true;
    } else {
      this.imageURL__I = v || undefined;
      this.imageURLIsSet = false;
    }
    this.changeTracker = true;
  }
  get imageURL() {
    return this.imageURL__I;
  }
  itemSKU__I?: string = undefined;
  itemSKUIsSet: boolean = false;
  set itemSKU(v: undefined | string) {
    if (v !== undefined) {
      this.itemSKU__I = v;
      this.itemSKUIsSet = true;
    } else {
      this.itemSKU__I = v || undefined;
      this.itemSKUIsSet = false;
    }
    this.changeTracker = true;
  }
  get itemSKU() {
    return this.itemSKU__I;
  }
  squareItemId__I?: string = undefined;
  squareItemIdIsSet: boolean = false;
  set squareItemId(v: undefined | string) {
    if (v !== undefined) {
      this.squareItemId__I = v;
      this.squareItemIdIsSet = true;
    } else {
      this.squareItemId__I = v || undefined;
      this.squareItemIdIsSet = false;
    }
    this.changeTracker = true;
  }
  get squareItemId() {
    return this.squareItemId__I;
  }
  expirationDurationSeconds__I?: number = undefined;
  expirationDurationSecondsIsSet: boolean = false;
  set expirationDurationSeconds(v: undefined | number) {
    if (v !== undefined) {
      this.expirationDurationSeconds__I = v;
      this.expirationDurationSecondsIsSet = true;
    } else {
      this.expirationDurationSeconds__I = v || undefined;
      this.expirationDurationSecondsIsSet = false;
    }
    this.changeTracker = true;
  }
  get expirationDurationSeconds() {
    return this.expirationDurationSeconds__I;
  }
  classTypeId__I?: ApClassTypeRefTracked = undefined;
  classTypeIdIsSet: boolean = false;
  set classTypeId(v: undefined | ApClassTypeRefTracked) {
    if (v !== undefined) {
      this.classTypeId__I = v;
      this.classTypeIdIsSet = true;
    } else {
      this.classTypeId__I = v || undefined;
      this.classTypeIdIsSet = false;
    }
    this.changeTracker = true;
  }
  get classTypeId() {
    return this.classTypeId__I;
  }
  classInstanceId__I?: ApClassInstanceRefTracked = undefined;
  classInstanceIdIsSet: boolean = false;
  set classInstanceId(v: undefined | ApClassInstanceRefTracked) {
    if (v !== undefined) {
      this.classInstanceId__I = v;
      this.classInstanceIdIsSet = true;
    } else {
      this.classInstanceId__I = v || undefined;
      this.classInstanceIdIsSet = false;
    }
    this.changeTracker = true;
  }
  get classInstanceId() {
    return this.classInstanceId__I;
  }
  membershipTypeId__I?: MembershipTypeRefTracked = undefined;
  membershipTypeIdIsSet: boolean = false;
  set membershipTypeId(v: undefined | MembershipTypeRefTracked) {
    if (v !== undefined) {
      this.membershipTypeId__I = v;
      this.membershipTypeIdIsSet = true;
    } else {
      this.membershipTypeId__I = v || undefined;
      this.membershipTypeIdIsSet = false;
    }
    this.changeTracker = true;
  }
  get membershipTypeId() {
    return this.membershipTypeId__I;
  }
  damageWaiverTypeId__I?: DamageWaiverTypeRefTracked = undefined;
  damageWaiverTypeIdIsSet: boolean = false;
  set damageWaiverTypeId(v: undefined | DamageWaiverTypeRefTracked) {
    if (v !== undefined) {
      this.damageWaiverTypeId__I = v;
      this.damageWaiverTypeIdIsSet = true;
    } else {
      this.damageWaiverTypeId__I = v || undefined;
      this.damageWaiverTypeIdIsSet = false;
    }
    this.changeTracker = true;
  }
  get damageWaiverTypeId() {
    return this.damageWaiverTypeId__I;
  }
  productId__I?: ProductRefTracked = undefined;
  productIdIsSet: boolean = false;
  set productId(v: undefined | ProductRefTracked) {
    if (v !== undefined) {
      this.productId__I = v;
      this.productIdIsSet = true;
    } else {
      this.productId__I = v || undefined;
      this.productIdIsSet = false;
    }
    this.changeTracker = true;
  }
  get productId() {
    return this.productId__I;
  }
  itemInstances__I?: CatalogItemInstanceDTOTracked[] = undefined;
  itemInstancesIsSet: boolean = false;
  set itemInstances(v: undefined | CatalogItemInstanceDTOTracked[]) {
    if (v !== undefined) {
      this.itemInstances__I = v;
      this.itemInstancesIsSet = true;
    } else {
      this.itemInstances__I = v || undefined;
      this.itemInstancesIsSet = false;
    }
    this.changeTracker = true;
  }
  get itemInstances() {
    return this.itemInstances__I;
  }
  itemCategories__I?: CatalogItemCategoryDTOTracked[] = undefined;
  itemCategoriesIsSet: boolean = false;
  set itemCategories(v: undefined | CatalogItemCategoryDTOTracked[]) {
    if (v !== undefined) {
      this.itemCategories__I = v;
      this.itemCategoriesIsSet = true;
    } else {
      this.itemCategories__I = v || undefined;
      this.itemCategoriesIsSet = false;
    }
    this.changeTracker = true;
  }
  get itemCategories() {
    return this.itemCategories__I;
  }
  itemAgreements__I?: ItemAgreementDTOTracked[] = undefined;
  itemAgreementsIsSet: boolean = false;
  set itemAgreements(v: undefined | ItemAgreementDTOTracked[]) {
    if (v !== undefined) {
      this.itemAgreements__I = v;
      this.itemAgreementsIsSet = true;
    } else {
      this.itemAgreements__I = v || undefined;
      this.itemAgreementsIsSet = false;
    }
    this.changeTracker = true;
  }
  get itemAgreements() {
    return this.itemAgreements__I;
  }
  updatedOn__I?: Date = undefined;
  updatedOnIsSet: boolean = false;
  set updatedOn(v: undefined | Date) {
    if (v !== undefined) {
      this.updatedOn__I = v;
      this.updatedOnIsSet = true;
    } else {
      this.updatedOn__I = v || undefined;
      this.updatedOnIsSet = false;
    }
    this.changeTracker = true;
  }
  get updatedOn() {
    return this.updatedOn__I;
  }
  updatedBy__I?: string = undefined;
  updatedByIsSet: boolean = false;
  set updatedBy(v: undefined | string) {
    if (v !== undefined) {
      this.updatedBy__I = v;
      this.updatedByIsSet = true;
    } else {
      this.updatedBy__I = v || undefined;
      this.updatedByIsSet = false;
    }
    this.changeTracker = true;
  }
  get updatedBy() {
    return this.updatedBy__I;
  }
  createdOn__I?: Date = undefined;
  createdOnIsSet: boolean = false;
  set createdOn(v: undefined | Date) {
    if (v !== undefined) {
      this.createdOn__I = v;
      this.createdOnIsSet = true;
    } else {
      this.createdOn__I = v || undefined;
      this.createdOnIsSet = false;
    }
    this.changeTracker = true;
  }
  get createdOn() {
    return this.createdOn__I;
  }
  createdBy__I?: string = undefined;
  createdByIsSet: boolean = false;
  set createdBy(v: undefined | string) {
    if (v !== undefined) {
      this.createdBy__I = v;
      this.createdByIsSet = true;
    } else {
      this.createdBy__I = v || undefined;
      this.createdByIsSet = false;
    }
    this.changeTracker = true;
  }
  get createdBy() {
    return this.createdBy__I;
  }
  itemDiscounts__I?: CatalogItemDiscountDTOTracked[] = undefined;
  itemDiscountsIsSet: boolean = false;
  set itemDiscounts(v: undefined | CatalogItemDiscountDTOTracked[]) {
    if (v !== undefined) {
      this.itemDiscounts__I = v;
      this.itemDiscountsIsSet = true;
    } else {
      this.itemDiscounts__I = v || undefined;
      this.itemDiscountsIsSet = false;
    }
    this.changeTracker = true;
  }
  get itemDiscounts() {
    return this.itemDiscounts__I;
  }
  itemTaxes__I?: CatalogItemTaxDTOTracked[] = undefined;
  itemTaxesIsSet: boolean = false;
  set itemTaxes(v: undefined | CatalogItemTaxDTOTracked[]) {
    if (v !== undefined) {
      this.itemTaxes__I = v;
      this.itemTaxesIsSet = true;
    } else {
      this.itemTaxes__I = v || undefined;
      this.itemTaxesIsSet = false;
    }
    this.changeTracker = true;
  }
  get itemTaxes() {
    return this.itemTaxes__I;
  }
  constructor(config?: CatalogItemDTOOptional, options?: AssignOptions) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    if (this.assignIdIsSet == true && other?.assignIdIsSet == true)
      return this.assignId == other.assignId;
    if (this.tempIDIsSet == true && other?.tempIDIsSet == true)
      return this.tempID == other.tempID;

    return this == other;
  }
  setIds() {
    if (this.anySet() && !!this.assignId) {
      this.assignIdIsSet = true;
    }

    this.classTypeId?.setIds();

    this.classInstanceId?.setIds();

    this.membershipTypeId?.setIds();

    this.damageWaiverTypeId?.setIds();

    this.productId?.setIds();

    this.itemInstances?.forEach((a) => a.setIds());

    this.itemCategories?.forEach((a) => a.setIds());

    this.itemAgreements?.forEach((a) => a.setIds());

    this.itemDiscounts?.forEach((a) => a.setIds());

    this.itemTaxes?.forEach((a) => a.setIds());
  }
  assignFrom(
    config: CatalogItemDTOOptional,
    options?: AssignOptions,
  ): CatalogItemDTOTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.isDeleted && this.isDeletedApplyFilter(optionsRequired.filter)) {
      this.isDeleted = config.isDeleted;
      if (optionsRequired.unassign) this.isDeletedIsSet = false;
      else this.isDeletedIsSet = true;
    }
    if (config.isNew && this.isNewApplyFilter(optionsRequired.filter)) {
      this.isNew = config.isNew;
      if (optionsRequired.unassign) this.isNewIsSet = false;
      else this.isNewIsSet = true;
    }
    if (config.assignId && this.assignIdApplyFilter(optionsRequired.filter)) {
      this.assignId = config.assignId;
      if (optionsRequired.unassign) this.assignIdIsSet = false;
      else this.assignIdIsSet = true;
    }
    if (config.tempID && this.tempIDApplyFilter(optionsRequired.filter)) {
      this.tempID = config.tempID;
      if (optionsRequired.unassign) this.tempIDIsSet = false;
      else this.tempIDIsSet = true;
    }
    if (config.itemType && this.itemTypeApplyFilter(optionsRequired.filter)) {
      this.itemType = config.itemType;
      if (optionsRequired.unassign) this.itemTypeIsSet = false;
      else this.itemTypeIsSet = true;
    }
    if (config.itemName && this.itemNameApplyFilter(optionsRequired.filter)) {
      this.itemName = config.itemName;
      if (optionsRequired.unassign) this.itemNameIsSet = false;
      else this.itemNameIsSet = true;
    }
    if (
      config.itemDescription &&
      this.itemDescriptionApplyFilter(optionsRequired.filter)
    ) {
      this.itemDescription = config.itemDescription;
      if (optionsRequired.unassign) this.itemDescriptionIsSet = false;
      else this.itemDescriptionIsSet = true;
    }
    if (config.imageURL && this.imageURLApplyFilter(optionsRequired.filter)) {
      this.imageURL = config.imageURL;
      if (optionsRequired.unassign) this.imageURLIsSet = false;
      else this.imageURLIsSet = true;
    }
    if (config.itemSKU && this.itemSKUApplyFilter(optionsRequired.filter)) {
      this.itemSKU = config.itemSKU;
      if (optionsRequired.unassign) this.itemSKUIsSet = false;
      else this.itemSKUIsSet = true;
    }
    if (
      config.squareItemId &&
      this.squareItemIdApplyFilter(optionsRequired.filter)
    ) {
      this.squareItemId = config.squareItemId;
      if (optionsRequired.unassign) this.squareItemIdIsSet = false;
      else this.squareItemIdIsSet = true;
    }
    if (
      config.expirationDurationSeconds &&
      this.expirationDurationSecondsApplyFilter(optionsRequired.filter)
    ) {
      this.expirationDurationSeconds = config.expirationDurationSeconds;
      if (optionsRequired.unassign) this.expirationDurationSecondsIsSet = false;
      else this.expirationDurationSecondsIsSet = true;
    }
    if (
      config.classTypeId &&
      this.classTypeIdApplyFilter(optionsRequired.filter)
    ) {
      this.classTypeId = new ApClassTypeRefTracked(config.classTypeId, options);
      if (optionsRequired.unassign) this.classTypeIdIsSet = false;
      else this.classTypeIdIsSet = true;
    }
    if (
      config.classInstanceId &&
      this.classInstanceIdApplyFilter(optionsRequired.filter)
    ) {
      this.classInstanceId = new ApClassInstanceRefTracked(
        config.classInstanceId,
        options,
      );
      if (optionsRequired.unassign) this.classInstanceIdIsSet = false;
      else this.classInstanceIdIsSet = true;
    }
    if (
      config.membershipTypeId &&
      this.membershipTypeIdApplyFilter(optionsRequired.filter)
    ) {
      this.membershipTypeId = new MembershipTypeRefTracked(
        config.membershipTypeId,
        options,
      );
      if (optionsRequired.unassign) this.membershipTypeIdIsSet = false;
      else this.membershipTypeIdIsSet = true;
    }
    if (
      config.damageWaiverTypeId &&
      this.damageWaiverTypeIdApplyFilter(optionsRequired.filter)
    ) {
      this.damageWaiverTypeId = new DamageWaiverTypeRefTracked(
        config.damageWaiverTypeId,
        options,
      );
      if (optionsRequired.unassign) this.damageWaiverTypeIdIsSet = false;
      else this.damageWaiverTypeIdIsSet = true;
    }
    if (config.productId && this.productIdApplyFilter(optionsRequired.filter)) {
      this.productId = new ProductRefTracked(config.productId, options);
      if (optionsRequired.unassign) this.productIdIsSet = false;
      else this.productIdIsSet = true;
    }
    if (
      config.itemInstances &&
      this.itemInstancesApplyFilter(optionsRequired.filter)
    ) {
      this.itemInstances = config.itemInstances?.map(
        (a) => new CatalogItemInstanceDTOTracked(a, options),
      );
      if (optionsRequired.unassign) this.itemInstancesIsSet = false;
      else this.itemInstancesIsSet = true;
    }
    if (
      config.itemCategories &&
      this.itemCategoriesApplyFilter(optionsRequired.filter)
    ) {
      this.itemCategories = config.itemCategories?.map(
        (a) => new CatalogItemCategoryDTOTracked(a, options),
      );
      if (optionsRequired.unassign) this.itemCategoriesIsSet = false;
      else this.itemCategoriesIsSet = true;
    }
    if (
      config.itemAgreements &&
      this.itemAgreementsApplyFilter(optionsRequired.filter)
    ) {
      this.itemAgreements = config.itemAgreements?.map(
        (a) => new ItemAgreementDTOTracked(a, options),
      );
      if (optionsRequired.unassign) this.itemAgreementsIsSet = false;
      else this.itemAgreementsIsSet = true;
    }
    if (config.updatedOn && this.updatedOnApplyFilter(optionsRequired.filter)) {
      this.updatedOn = config.updatedOn;
      if (optionsRequired.unassign) this.updatedOnIsSet = false;
      else this.updatedOnIsSet = true;
    }
    if (config.updatedBy && this.updatedByApplyFilter(optionsRequired.filter)) {
      this.updatedBy = config.updatedBy;
      if (optionsRequired.unassign) this.updatedByIsSet = false;
      else this.updatedByIsSet = true;
    }
    if (config.createdOn && this.createdOnApplyFilter(optionsRequired.filter)) {
      this.createdOn = config.createdOn;
      if (optionsRequired.unassign) this.createdOnIsSet = false;
      else this.createdOnIsSet = true;
    }
    if (config.createdBy && this.createdByApplyFilter(optionsRequired.filter)) {
      this.createdBy = config.createdBy;
      if (optionsRequired.unassign) this.createdByIsSet = false;
      else this.createdByIsSet = true;
    }
    if (
      config.itemDiscounts &&
      this.itemDiscountsApplyFilter(optionsRequired.filter)
    ) {
      this.itemDiscounts = config.itemDiscounts?.map(
        (a) => new CatalogItemDiscountDTOTracked(a, options),
      );
      if (optionsRequired.unassign) this.itemDiscountsIsSet = false;
      else this.itemDiscountsIsSet = true;
    }
    if (config.itemTaxes && this.itemTaxesApplyFilter(optionsRequired.filter)) {
      this.itemTaxes = config.itemTaxes?.map(
        (a) => new CatalogItemTaxDTOTracked(a, options),
      );
      if (optionsRequired.unassign) this.itemTaxesIsSet = false;
      else this.itemTaxesIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): CatalogItemDTOTrackedI {
    const cloned = {} as CatalogItemDTOTrackedI;
    if (
      this.isDeletedIsSetDeep() &&
      this.isDeletedApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isDeletedIsSet = true;
      cloned.isDeleted = this.isDeleted;
    } else {
      //cloned.isDeletedIsSet = false
    }
    if (
      this.isNewIsSetDeep() &&
      this.isNewApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isNewIsSet = true;
      cloned.isNew = this.isNew;
    } else {
      //cloned.isNewIsSet = false
    }
    if (
      this.assignIdIsSetDeep() &&
      this.assignIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.assignIdIsSet = true;
      cloned.assignId = this.assignId;
    } else {
      //cloned.assignIdIsSet = false
    }
    if (
      this.tempIDIsSetDeep() &&
      this.tempIDApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.tempIDIsSet = true;
      cloned.tempID = this.tempID;
    } else {
      //cloned.tempIDIsSet = false
    }
    if (
      this.itemTypeIsSetDeep() &&
      this.itemTypeApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.itemTypeIsSet = true;
      cloned.itemType = this.itemType;
    } else {
      //cloned.itemTypeIsSet = false
    }
    if (
      this.itemNameIsSetDeep() &&
      this.itemNameApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.itemNameIsSet = true;
      cloned.itemName = this.itemName;
    } else {
      //cloned.itemNameIsSet = false
    }
    if (
      this.itemDescriptionIsSetDeep() &&
      this.itemDescriptionApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.itemDescriptionIsSet = true;
      cloned.itemDescription = this.itemDescription;
    } else {
      //cloned.itemDescriptionIsSet = false
    }
    if (
      this.imageURLIsSetDeep() &&
      this.imageURLApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.imageURLIsSet = true;
      cloned.imageURL = this.imageURL;
    } else {
      //cloned.imageURLIsSet = false
    }
    if (
      this.itemSKUIsSetDeep() &&
      this.itemSKUApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.itemSKUIsSet = true;
      cloned.itemSKU = this.itemSKU;
    } else {
      //cloned.itemSKUIsSet = false
    }
    if (
      this.squareItemIdIsSetDeep() &&
      this.squareItemIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.squareItemIdIsSet = true;
      cloned.squareItemId = this.squareItemId;
    } else {
      //cloned.squareItemIdIsSet = false
    }
    if (
      this.expirationDurationSecondsIsSetDeep() &&
      this.expirationDurationSecondsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.expirationDurationSecondsIsSet = true;
      cloned.expirationDurationSeconds = this.expirationDurationSeconds;
    } else {
      //cloned.expirationDurationSecondsIsSet = false
    }
    if (
      this.classTypeIdIsSetDeep() &&
      this.classTypeIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.classTypeIdIsSet = true;
      cloned.classTypeId = this.classTypeId?.removeUnset(filter);
    } else {
      //cloned.classTypeIdIsSet = false
    }
    if (
      this.classInstanceIdIsSetDeep() &&
      this.classInstanceIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.classInstanceIdIsSet = true;
      cloned.classInstanceId = this.classInstanceId?.removeUnset(filter);
    } else {
      //cloned.classInstanceIdIsSet = false
    }
    if (
      this.membershipTypeIdIsSetDeep() &&
      this.membershipTypeIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.membershipTypeIdIsSet = true;
      cloned.membershipTypeId = this.membershipTypeId?.removeUnset(filter);
    } else {
      //cloned.membershipTypeIdIsSet = false
    }
    if (
      this.damageWaiverTypeIdIsSetDeep() &&
      this.damageWaiverTypeIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.damageWaiverTypeIdIsSet = true;
      cloned.damageWaiverTypeId = this.damageWaiverTypeId?.removeUnset(filter);
    } else {
      //cloned.damageWaiverTypeIdIsSet = false
    }
    if (
      this.productIdIsSetDeep() &&
      this.productIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.productIdIsSet = true;
      cloned.productId = this.productId?.removeUnset(filter);
    } else {
      //cloned.productIdIsSet = false
    }
    if (
      this.itemInstancesIsSetDeep((a, b) => !a.isPrimary || !b.isArray) &&
      this.itemInstancesApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.itemInstancesIsSet = true;
      cloned.itemInstances = this.itemInstances
        ?.filter((a) => !a.shouldRemove(true))
        ?.map((a) => a.removeUnset(filter));
    } else {
      //cloned.itemInstancesIsSet = false
    }
    if (
      this.itemCategoriesIsSetDeep((a, b) => !a.isPrimary || !b.isArray) &&
      this.itemCategoriesApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.itemCategoriesIsSet = true;
      cloned.itemCategories = this.itemCategories
        ?.filter((a) => !a.shouldRemove(true))
        ?.map((a) => a.removeUnset(filter));
    } else {
      //cloned.itemCategoriesIsSet = false
    }
    if (
      this.itemAgreementsIsSetDeep((a, b) => !a.isPrimary || !b.isArray) &&
      this.itemAgreementsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.itemAgreementsIsSet = true;
      cloned.itemAgreements = this.itemAgreements
        ?.filter((a) => !a.shouldRemove(true))
        ?.map((a) => a.removeUnset(filter));
    } else {
      //cloned.itemAgreementsIsSet = false
    }
    if (
      this.updatedOnIsSetDeep() &&
      this.updatedOnApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.updatedOnIsSet = true;
      cloned.updatedOn = this.updatedOn;
    } else {
      //cloned.updatedOnIsSet = false
    }
    if (
      this.updatedByIsSetDeep() &&
      this.updatedByApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.updatedByIsSet = true;
      cloned.updatedBy = this.updatedBy;
    } else {
      //cloned.updatedByIsSet = false
    }
    if (
      this.createdOnIsSetDeep() &&
      this.createdOnApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.createdOnIsSet = true;
      cloned.createdOn = this.createdOn;
    } else {
      //cloned.createdOnIsSet = false
    }
    if (
      this.createdByIsSetDeep() &&
      this.createdByApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.createdByIsSet = true;
      cloned.createdBy = this.createdBy;
    } else {
      //cloned.createdByIsSet = false
    }
    if (
      this.itemDiscountsIsSetDeep((a, b) => !a.isPrimary || !b.isArray) &&
      this.itemDiscountsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.itemDiscountsIsSet = true;
      cloned.itemDiscounts = this.itemDiscounts
        ?.filter((a) => !a.shouldRemove(true))
        ?.map((a) => a.removeUnset(filter));
    } else {
      //cloned.itemDiscountsIsSet = false
    }
    if (
      this.itemTaxesIsSetDeep((a, b) => !a.isPrimary || !b.isArray) &&
      this.itemTaxesApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.itemTaxesIsSet = true;
      cloned.itemTaxes = this.itemTaxes
        ?.filter((a) => !a.shouldRemove(true))
        ?.map((a) => a.removeUnset(filter));
    } else {
      //cloned.itemTaxesIsSet = false
    }
    if (!isDeleted(this) && !this.assignIdIsSet) updateIsNew(cloned, true);
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): CatalogItemDTOTrackedI {
    if (!this.isDeletedApplyFilter(filter)) this.isDeletedIsSet = false;

    if (!this.isNewApplyFilter(filter)) this.isNewIsSet = false;

    if (!this.assignIdApplyFilter(filter)) this.assignIdIsSet = false;

    if (!this.tempIDApplyFilter(filter)) this.tempIDIsSet = false;

    if (!this.itemTypeApplyFilter(filter)) this.itemTypeIsSet = false;

    if (!this.itemNameApplyFilter(filter)) this.itemNameIsSet = false;

    if (!this.itemDescriptionApplyFilter(filter))
      this.itemDescriptionIsSet = false;

    if (!this.imageURLApplyFilter(filter)) this.imageURLIsSet = false;

    if (!this.itemSKUApplyFilter(filter)) this.itemSKUIsSet = false;

    if (!this.squareItemIdApplyFilter(filter)) this.squareItemIdIsSet = false;

    if (!this.expirationDurationSecondsApplyFilter(filter))
      this.expirationDurationSecondsIsSet = false;

    if (!this.classTypeIdApplyFilter(filter)) this.classTypeIdIsSet = false;
    this.classTypeId?.unassignAll(filter);

    if (!this.classInstanceIdApplyFilter(filter))
      this.classInstanceIdIsSet = false;
    this.classInstanceId?.unassignAll(filter);

    if (!this.membershipTypeIdApplyFilter(filter))
      this.membershipTypeIdIsSet = false;
    this.membershipTypeId?.unassignAll(filter);

    if (!this.damageWaiverTypeIdApplyFilter(filter))
      this.damageWaiverTypeIdIsSet = false;
    this.damageWaiverTypeId?.unassignAll(filter);

    if (!this.productIdApplyFilter(filter)) this.productIdIsSet = false;
    this.productId?.unassignAll(filter);

    if (!this.itemInstancesApplyFilter(filter)) this.itemInstancesIsSet = false;

    this.itemInstances?.forEach((a) => a.unassignAll(filter));
    if (!this.itemCategoriesApplyFilter(filter))
      this.itemCategoriesIsSet = false;

    this.itemCategories?.forEach((a) => a.unassignAll(filter));
    if (!this.itemAgreementsApplyFilter(filter))
      this.itemAgreementsIsSet = false;

    this.itemAgreements?.forEach((a) => a.unassignAll(filter));
    if (!this.updatedOnApplyFilter(filter)) this.updatedOnIsSet = false;

    if (!this.updatedByApplyFilter(filter)) this.updatedByIsSet = false;

    if (!this.createdOnApplyFilter(filter)) this.createdOnIsSet = false;

    if (!this.createdByApplyFilter(filter)) this.createdByIsSet = false;

    if (!this.itemDiscountsApplyFilter(filter)) this.itemDiscountsIsSet = false;

    this.itemDiscounts?.forEach((a) => a.unassignAll(filter));
    if (!this.itemTaxesApplyFilter(filter)) this.itemTaxesIsSet = false;

    this.itemTaxes?.forEach((a) => a.unassignAll(filter));
    return this;
  }
  isDeletedApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogItemDTOMeta.isDeleted,
      CatalogItemDTOMeta,
      this.isDeleted,
      this,
    );
  }
  isDeletedIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isDeletedIsSet && this.isDeletedApplyFilter(filter)) return true;

    return false;
  }
  isNewApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogItemDTOMeta.isNew,
      CatalogItemDTOMeta,
      this.isNew,
      this,
    );
  }
  isNewIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isNewIsSet && this.isNewApplyFilter(filter)) return true;

    return false;
  }
  assignIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogItemDTOMeta.assignId,
      CatalogItemDTOMeta,
      this.assignId,
      this,
    );
  }
  assignIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.assignIdIsSet && this.assignIdApplyFilter(filter)) return true;

    return false;
  }
  tempIDApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogItemDTOMeta.tempID,
      CatalogItemDTOMeta,
      this.tempID,
      this,
    );
  }
  tempIDIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.tempIDIsSet && this.tempIDApplyFilter(filter)) return true;

    return false;
  }
  itemTypeApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogItemDTOMeta.itemType,
      CatalogItemDTOMeta,
      this.itemType,
      this,
    );
  }
  itemTypeIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.itemTypeIsSet && this.itemTypeApplyFilter(filter)) return true;

    return false;
  }
  itemNameApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogItemDTOMeta.itemName,
      CatalogItemDTOMeta,
      this.itemName,
      this,
    );
  }
  itemNameIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.itemNameIsSet && this.itemNameApplyFilter(filter)) return true;

    return false;
  }
  itemDescriptionApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogItemDTOMeta.itemDescription,
      CatalogItemDTOMeta,
      this.itemDescription,
      this,
    );
  }
  itemDescriptionIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.itemDescriptionIsSet && this.itemDescriptionApplyFilter(filter))
      return true;

    return false;
  }
  imageURLApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogItemDTOMeta.imageURL,
      CatalogItemDTOMeta,
      this.imageURL,
      this,
    );
  }
  imageURLIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.imageURLIsSet && this.imageURLApplyFilter(filter)) return true;

    return false;
  }
  itemSKUApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogItemDTOMeta.itemSKU,
      CatalogItemDTOMeta,
      this.itemSKU,
      this,
    );
  }
  itemSKUIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.itemSKUIsSet && this.itemSKUApplyFilter(filter)) return true;

    return false;
  }
  squareItemIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogItemDTOMeta.squareItemId,
      CatalogItemDTOMeta,
      this.squareItemId,
      this,
    );
  }
  squareItemIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.squareItemIdIsSet && this.squareItemIdApplyFilter(filter))
      return true;

    return false;
  }
  expirationDurationSecondsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogItemDTOMeta.expirationDurationSeconds,
      CatalogItemDTOMeta,
      this.expirationDurationSeconds,
      this,
    );
  }
  expirationDurationSecondsIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.expirationDurationSecondsIsSet &&
      this.expirationDurationSecondsApplyFilter(filter)
    )
      return true;

    return false;
  }
  classTypeIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogItemDTOMeta.classTypeId,
      CatalogItemDTOMeta,
      this.classTypeId,
      this,
    );
  }
  classTypeIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.classTypeIdIsSet && this.classTypeIdApplyFilter(filter))
      return true;
    return this.classTypeId?.anySet(filter) == true;

    return false;
  }
  classInstanceIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogItemDTOMeta.classInstanceId,
      CatalogItemDTOMeta,
      this.classInstanceId,
      this,
    );
  }
  classInstanceIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.classInstanceIdIsSet && this.classInstanceIdApplyFilter(filter))
      return true;
    return this.classInstanceId?.anySet(filter) == true;

    return false;
  }
  membershipTypeIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogItemDTOMeta.membershipTypeId,
      CatalogItemDTOMeta,
      this.membershipTypeId,
      this,
    );
  }
  membershipTypeIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.membershipTypeIdIsSet && this.membershipTypeIdApplyFilter(filter))
      return true;
    return this.membershipTypeId?.anySet(filter) == true;

    return false;
  }
  damageWaiverTypeIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogItemDTOMeta.damageWaiverTypeId,
      CatalogItemDTOMeta,
      this.damageWaiverTypeId,
      this,
    );
  }
  damageWaiverTypeIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.damageWaiverTypeIdIsSet &&
      this.damageWaiverTypeIdApplyFilter(filter)
    )
      return true;
    return this.damageWaiverTypeId?.anySet(filter) == true;

    return false;
  }
  productIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogItemDTOMeta.productId,
      CatalogItemDTOMeta,
      this.productId,
      this,
    );
  }
  productIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.productIdIsSet && this.productIdApplyFilter(filter)) return true;
    return this.productId?.anySet(filter) == true;

    return false;
  }
  itemInstancesApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogItemDTOMeta.itemInstances,
      CatalogItemDTOMeta,
      this.itemInstances,
      this,
    );
  }
  itemInstancesIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.itemInstancesIsSet && this.itemInstancesApplyFilter(filter))
      return true;

    return this.itemInstances?.find((a) => a.anySet(filter)) != undefined;
    return false;
  }
  itemCategoriesApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogItemDTOMeta.itemCategories,
      CatalogItemDTOMeta,
      this.itemCategories,
      this,
    );
  }
  itemCategoriesIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.itemCategoriesIsSet && this.itemCategoriesApplyFilter(filter))
      return true;

    return this.itemCategories?.find((a) => a.anySet(filter)) != undefined;
    return false;
  }
  itemAgreementsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogItemDTOMeta.itemAgreements,
      CatalogItemDTOMeta,
      this.itemAgreements,
      this,
    );
  }
  itemAgreementsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.itemAgreementsIsSet && this.itemAgreementsApplyFilter(filter))
      return true;

    return this.itemAgreements?.find((a) => a.anySet(filter)) != undefined;
    return false;
  }
  updatedOnApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogItemDTOMeta.updatedOn,
      CatalogItemDTOMeta,
      this.updatedOn,
      this,
    );
  }
  updatedOnIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.updatedOnIsSet && this.updatedOnApplyFilter(filter)) return true;

    return false;
  }
  updatedByApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogItemDTOMeta.updatedBy,
      CatalogItemDTOMeta,
      this.updatedBy,
      this,
    );
  }
  updatedByIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.updatedByIsSet && this.updatedByApplyFilter(filter)) return true;

    return false;
  }
  createdOnApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogItemDTOMeta.createdOn,
      CatalogItemDTOMeta,
      this.createdOn,
      this,
    );
  }
  createdOnIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.createdOnIsSet && this.createdOnApplyFilter(filter)) return true;

    return false;
  }
  createdByApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogItemDTOMeta.createdBy,
      CatalogItemDTOMeta,
      this.createdBy,
      this,
    );
  }
  createdByIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.createdByIsSet && this.createdByApplyFilter(filter)) return true;

    return false;
  }
  itemDiscountsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogItemDTOMeta.itemDiscounts,
      CatalogItemDTOMeta,
      this.itemDiscounts,
      this,
    );
  }
  itemDiscountsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.itemDiscountsIsSet && this.itemDiscountsApplyFilter(filter))
      return true;

    return this.itemDiscounts?.find((a) => a.anySet(filter)) != undefined;
    return false;
  }
  itemTaxesApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogItemDTOMeta.itemTaxes,
      CatalogItemDTOMeta,
      this.itemTaxes,
      this,
    );
  }
  itemTaxesIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.itemTaxesIsSet && this.itemTaxesApplyFilter(filter)) return true;

    return this.itemTaxes?.find((a) => a.anySet(filter)) != undefined;
    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.isDeletedIsSetDeep(filter)) return true;
    if (this.isNewIsSetDeep(filter)) return true;
    if (this.assignIdIsSetDeep(filter)) return true;
    if (this.tempIDIsSetDeep(filter)) return true;
    if (this.itemTypeIsSetDeep(filter)) return true;
    if (this.itemNameIsSetDeep(filter)) return true;
    if (this.itemDescriptionIsSetDeep(filter)) return true;
    if (this.imageURLIsSetDeep(filter)) return true;
    if (this.itemSKUIsSetDeep(filter)) return true;
    if (this.squareItemIdIsSetDeep(filter)) return true;
    if (this.expirationDurationSecondsIsSetDeep(filter)) return true;
    if (this.classTypeIdIsSetDeep(filter)) return true;
    if (this.classInstanceIdIsSetDeep(filter)) return true;
    if (this.membershipTypeIdIsSetDeep(filter)) return true;
    if (this.damageWaiverTypeIdIsSetDeep(filter)) return true;
    if (this.productIdIsSetDeep(filter)) return true;
    if (this.itemInstancesIsSetDeep(filter)) return true;
    if (this.itemCategoriesIsSetDeep(filter)) return true;
    if (this.itemAgreementsIsSetDeep(filter)) return true;
    if (this.updatedOnIsSetDeep(filter)) return true;
    if (this.updatedByIsSetDeep(filter)) return true;
    if (this.createdOnIsSetDeep(filter)) return true;
    if (this.createdByIsSetDeep(filter)) return true;
    if (this.itemDiscountsIsSetDeep(filter)) return true;
    if (this.itemTaxesIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
